import React, { memo } from 'react';
import { ModalType } from '../App';
interface FooterProps {
  onOpenModal: (type: ModalType) => void;
}
export function Footer({
  onOpenModal
}: FooterProps) {
  return <footer className="bg-base-950 border-t border-slate-800/50 py-12 md:py-16 relative" data-id="element-76">
      {/* Thin amber gradient line at the top */}
      <div className="absolute top-0 left-0 w-[30%] h-[1px] bg-gradient-to-r from-gold-400 to-transparent" data-id="element-77"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-78">
        <div className="mb-12" data-id="element-79">
          <div className="text-xl font-bold tracking-[0.2em] text-white flex items-center gap-2 mb-6" data-id="element-80">
            <div className="w-5 h-5 bg-gold-400 clip-triangle" style={{
            clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)'
          }} data-id="element-81"></div>
            DELTA STREET
          </div>
          <p className="text-slate-500 text-sm leading-relaxed max-w-md mb-4" data-id="element-82">
            Delta Street is a DBA of 22Fund LLC — an alternative investment firm
            focused on structural market opportunities, policy-driven catalysts,
            and macro positioning.
          </p>
          <a href="mailto:investors@deltastreet.co" className="text-slate-400 text-sm hover:text-gold-400 transition-colors" data-id="element-83">
            investors@deltastreet.co
          </a>
        </div>

        <div className="border-t border-slate-900 pt-8 text-xs text-slate-600 leading-relaxed" data-id="element-84">
          <p className="mb-4" data-id="element-85">
            Disclaimer: The information contained on this website is for
            informational purposes only and does not constitute an offer to sell
            or a solicitation of an offer to buy any interest in any investment
            vehicle managed by 22Fund LLC (d/b/a Delta Street). Any such offer
            or solicitation will be made only by means of a confidential private
            placement memorandum and only in jurisdictions where permitted by
            law.
          </p>
          <p className="mb-4" data-id="element-86">
            Delta Street is a DBA of 22Fund LLC. Past performance is not
            indicative of future results. Investment in a hedge fund is
            speculative and involves a high degree of risk. The strategies
            described herein are subject to change without notice. This website
            does not constitute an offer to sell or solicitation of an offer to
            buy any securities.
          </p>
          <div className="flex flex-col md:flex-row justify-between items-center mt-8 pt-8 border-t border-slate-900/50" data-id="element-87">
            <p data-id="element-88">
              &copy; {new Date().getFullYear()} 22Fund LLC d/b/a Delta Street.
              All rights reserved.
            </p>
            <div className="flex gap-6 mt-4 md:mt-0" data-id="element-89">
              <button onClick={() => onOpenModal('terms')} className="hover:text-gold-400 transition-colors" data-id="element-90">
                Terms of Use
              </button>
              <button onClick={() => onOpenModal('privacy')} className="hover:text-gold-400 transition-colors" data-id="element-91">
                Privacy Policy
              </button>
              <button onClick={() => onOpenModal('adv')} className="hover:text-gold-400 transition-colors" data-id="element-92">
                Form ADV
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}